/**
 * 📦 V2 Coproducers API client
 * Rotas /api/v2/coproducers (vínculo coproducer × produto)
 * Spec: docs/V2/07_REGRAS_NEGOCIO.md §3.1 + §3.4
 */

import v2Api from './index';

export const coproducersV2API = {
  /**
   * Produtor convida coproducer.
   * Body: { product_id, user_id, commission_value_override? }
   */
  create: (data) => v2Api.post('/coproducers', data),

  /**
   * Convida coproducer por EMAIL. 409 CONFLICT se já existir coproducer ativo.
   * Body: { product_id, email, commission_value_override? }
   */
  invite: (data) => v2Api.post('/coproducers/invite', data),

  /** Lista coproducers do produto. */
  listByProduct: (productId) => v2Api.get(`/coproducers/by-product/${productId}`),

  /** Lista produtos onde o user é coproducer. */
  listMine: () => v2Api.get('/coproducers/me'),

  findById: (id) => v2Api.get(`/coproducers/${id}`),

  activate: (id) => v2Api.post(`/coproducers/${id}/activate`),

  deactivate: (id) => v2Api.post(`/coproducers/${id}/deactivate`),

  /** body: { commission_value_override } */
  updateCommissionOverride: (id, data) =>
    v2Api.patch(`/coproducers/${id}/commission-override`, data),

  remove: (id) => v2Api.delete(`/coproducers/${id}`),
};

export default coproducersV2API;
